import { useEffect, useRef, useState } from 'react';
import './hero-experience.css';

export function HeroExperience() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [failed, setFailed] = useState(false);
  const [started, setStarted] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) videoRef.current?.pause();
    });
    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, []);
  return (
    <figure className="fx-film fx-ld fx-d5">
      <div className="fx-film-frame">
        <video
          ref={videoRef}
          width="1920"
          height="1080"
          autoPlay={false}
          muted
          loop={false}
          playsInline
          controls={started}
          preload="metadata"
          poster="/media/foxet-platform-film-poster.jpg"
          aria-label="Foxet product film: personalised product conversations, workflow guidance and connected follow-up"
          onError={() => setFailed(true)}
          onPlay={() => setStarted(true)}
        >
          <source src="/media/foxet-platform-film.mp4" type="video/mp4" />
          <p>
            <a href="/media/foxet-platform-film.mp4">
              Watch the Foxet product film
            </a>
          </p>
        </video>
        {!started && (
          <button
            type="button"
            className="fx-film-play"
            aria-label="Play the Foxet product film"
            onClick={() => {
              setStarted(true);
              void videoRef.current?.play();
            }}
          >
            <i aria-hidden="true" />
          </button>
        )}
      </div>
      {failed && (
        <p className="fx-film-error" role="status">
          The video could not load.{' '}
          <a href="/media/foxet-platform-film.mp4">Open the film directly.</a>
        </p>
      )}
    </figure>
  );
}
